<div
  id="AssetOverviewMap-container"
  [class.mobile]="isMobile()"
  [class.desktop]="isDesktop()"
>
  @if (isLoading()) {
    <div class="spinner-container">
      <app-spinner />
    </div>
  }
  <div class="inset-shadow-container"></div>
  <div id="AssetOverviewMap"></div>
</div>
